import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../context/DataContext";
import { Link, useNavigate } from "react-router-dom";
import supabase from "../supabase/supabaseClient";

import estilo from "./styles/Menu.module.css";

function Menu() {
  const { usuario, actualizarUsuario, url, fotoSubida } =
    useContext(DataContext);

  let navigate = useNavigate();

  const [activar, setActivar] = useState(false);

  //traer datos
  useEffect(() => {
    const fetchDatos = async () => {
      setActivar(false);
      const { data, error } = await supabase
        .from("usuarios_chat")
        .select()
        .eq("user_id", usuario.id)
        .single();

      if (data) {
        setActivar(true);
      }
      if (error) {
        setActivar(false);
      }
    };

    fetchDatos();
  }, [fotoSubida]);

  //cerrar sesion
  async function salir() {
    actualizarEstado();
    const { error } = await supabase.auth.signOut();
    actualizarUsuario(null);
    localStorage.clear();
    navigate("/");
  }

  async function actualizarEstado() {
    const { data, error } = await supabase
      .from("usuarios_chat")
      .update({ estado: false })
      .eq("user_id", usuario.id);
  }

  return (
    <div className={estilo.menu}>
      <Link to={"/"}>
        <h1>
          S<em>Person</em>
        </h1>
      </Link>

      <div className={estilo.opciones}>
        <div className={estilo.perfil}>
          <div className={estilo.foto}>
            {activar ? (
              <img
                src={url + usuario.id}
                alt={usuario.user_metadata.first_name}
                width="50px"
                height="50px"
              />
            ) : null}
          </div>
          <h4>{usuario.user_metadata.first_name}</h4>
        </div>

        {usuario ? (
          <button onClick={salir}>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M19.002 3h-14c-1.103 0-2 .897-2 2v4h2V5h14v14h-14v-4h-2v4c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.898-2-2-2z"></path>
              <path d="m11 16 5-4-5-4v3.001H3v2h8z"></path>
            </svg>
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default Menu;
